import { createStore } from 'vuex'
import main from './main'
import sideMenu from './side-menu'
import auth from './auth'

const store = createStore({
  modules: {
    main,
    sideMenu,
    auth
  }
})

export function useStore() {
  return store
}

export default store
